<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('jd.jd_jdcom-store') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
        />
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, NormalButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    buttonName: { default: 'common.input_save' },
    shopData: { type: Object, require: false, default: () => ({}) },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 4,
      contentsCols: 8
    },
    inputData: {},
    items: [
      {
        name: 'name',
        text: 'jd.jd_jdcom-store-name',
        required: true
      },
      {
        name: 'platform',
        text: 'common.common_select-country-ec',
        required: true,
        component: 'SelectPlatform'
      },
      {
        name: 'sortNumber',
        text: 'common.input_sort-number',
        required: true,
        placeholder: '',
        cols: Math.ceil(2)
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('Platform', ['registerPlatform', 'editPlatform']),
    ...mapGetters('Platform', ['getMaxSortNumber']),

    init() {
      const formatData = _cloneDeep(this.shopData)
      formatData.sortNumber = this.editMode
        ? this.shopData.sortNumber
        : this.getMaxSortNumber() + 1
      formatData.platform = this.editMode
        ? { value: this.shopData.platformCountryId }
        : {}

      this.inputData = formatData
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.shopId
      }
      const success = this.editMode
        ? await this.editPlatform(this.inputData)
        : await this.registerPlatform(this.inputData)
      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
